// extracted by mini-css-extract-plugin
module.exports = {"relative":"ColorInput_relative__-aS6E","preview":"ColorInput_preview__14_FW","color":"ColorInput_color__10pFi"};